<template >
  <div class="new-home-packs">
    <div class="pack-box trial-offer" >
      <p class="discover text-uppercase">
        découvrez votre pack

        <span class="arrow-down"></span>
      </p>
      <h3>Profitez de votre offre <br> d'essai à <span class="purple-text">2€/2 mois</span></h3>
      <p class="text-uppercase purple-text">Vous bénéficiez de</p>
      <ul>
        <li>Votre cadeau de bienvenue au choix</li>
        <li>Vos magazines en version papier et/ou numérique </li>
        <li>Une assistance juridique, fiscale et technique illimitée</li>
        <li>12 guides pratiques au choix</li>
      </ul>
    </div>
      <GiftChoiceDynamic v-if="box === 'dynamic'"></GiftChoiceDynamic>
      <GiftChoiceList v-if="box === 'list'" ></GiftChoiceList>
      <GiftChoiceTableau v-if="box === 'tableau'" ></GiftChoiceTableau>
      <GiftChoiceTableauSchool v-if="box === 'school'" ></GiftChoiceTableauSchool>
      <GiftChoiceTableauAndroid v-if="box === 'android'" ></GiftChoiceTableauAndroid>
      <GiftChoiceTableauLenovo v-if="box === 'tableau_lenovo_coque'" ></GiftChoiceTableauLenovo>
<!--      <GiftChoiceArchos v-if="box === 'tableau-archos'"></GiftChoiceArchos>-->
      <GiftChoiceCooking v-if="box === 'cooking'" ></GiftChoiceCooking>
      <GiftChoiceCooking2024 v-if="box === 'cooking2024'" ></GiftChoiceCooking2024>
  </div>
</template>
<script>
import GiftChoiceDynamic from "./GiftChoiceDynamic";
import GiftChoiceList from "./GiftChoiceList";
import GiftChoiceTableau from "./GiftChoiceTableau";
import GiftChoiceTableauSchool from "./GiftChoiceTableauSchool";
import GiftChoiceTableauAndroid from "./GiftChoiceTableauAndroid";
import GiftChoiceTableauLenovo from "./GiftChoiceTableauLenovo";
import GiftChoiceArchos from "./GiftChoiceArchos";
import GiftChoiceCooking from "./GiftChoiceCooking";
import GiftChoiceCooking2024 from "./GiftChoiceCooking2024";
export default {
    components: {GiftChoiceCooking,GiftChoiceCooking2024, GiftChoiceTableau, GiftChoiceTableauSchool, GiftChoiceDynamic, GiftChoiceTableauAndroid, GiftChoiceList,GiftChoiceArchos,GiftChoiceTableauLenovo},
    props: {
        box: {
            type: String,
            default: 'list'
        },
    },
};
</script>
